import { render, staticRenderFns } from "./PaginationLink.vue?vue&type=template&id=eab48a8e&scoped=true"
import script from "./PaginationLink.vue?vue&type=script&lang=js"
export * from "./PaginationLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab48a8e",
  null
  
)

export default component.exports